<template>
    <!-- <el-scrollbar :style="{ height: this.screenHeight + 'px' }"> -->
    <div style="height: 100%" class="bedcardview">
        <el-row>
            <el-col :span="18" style="border: 0.5px solid lightgray">
                <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight - 216}px` }">
                    <el-col :span="6" v-for="room in alloperationRooms" :key="room.id" class="bed-card">
                        <el-card :class="{ active: active_room_id == room.id }">
                            <!-- <div>{{ room }}</div> -->
                            <div @click="active_room_id = room.id" style="position: relative">
                            <draggable
                                slot="header"
                                v-bind="{
                                    animation: 150,
                                    group: { name: `room`, pull: 'clone', put: true },
                                    disabled: false,
                                    ghostClass: `ghost`,
                                    sort: false
                                }"
                                tag="div"
                                class="header ellipsis cursor-pointer"
                                :component-data="getDraggleAttrs(room.id)"
                                :title="roomLabelTitle"
                                @remove="exchangeRoom"
                            >
                                <div style="display: flex; justify-content: space-between; font-size: 20px; height: 26px; line-height: 26px">
                                    <span>{{ room.done }}/{{ room.total }}</span>
                                    <span style="font-weight: bold">{{ room.title }}</span>
                                    <span style="font-size: 14px; cursor: pointer">
                                        <i class="el-icon-message-solid" title="当前手术间未具备手术资格" @click.stop="loadCheckList(room)" v-show="room.check_result == '不合格'"></i>
                                    </span>
                                    <span class="hasSetting" @click.stop="loadSettingForm(room.id, room.title, room)">
                                        <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                    </span>
                                </div>
                            </draggable>
                                <div class="content" @contextmenu.prevent="cancelWorkers($event, room)">
                                    <div v-if="room.anesthetist && room.anesthetist.length > 0" class="item">
                                        <el-col class="align-left" style="overflow-wrap: break-word; overflow: hidden; text-overflow: ellipsis" :span="24"
                                            >{{ T(`fullcalendar_schedule_surgery.plan_anes_doctor`) }}：{{ room.anesthetist }}
                                        </el-col>
                                    </div>
                                    <div v-if="room.anesthetist_assistant && room.anesthetist_assistant.length > 0" class="item">
                                        <el-col class="align-left" style="overflow-wrap: break-word; overflow: hidden; text-overflow: ellipsis"
                                            >{{ T(`fullcalendar_schedule_surgery.plan_anes_assistants`) }}：{{ room.anesthetist_assistant }}
                                        </el-col>
                                    </div>
                                    <div v-if="room.circuit_nurse && room.circuit_nurse.length > 0" class="item">
                                        <el-col class="align-left" style="overflow-wrap: break-word; overflow: hidden; text-overflow: ellipsis" :span="24"
                                            >{{ T(`fullcalendar_schedule_surgery.plan_circuit_nurse`) }}：{{ room.circuit_nurse }}
                                        </el-col>
                                    </div>
                                    <div v-if="room.equipment_nurse && room.equipment_nurse.length > 0" class="item">
                                        <el-col class="align-left" style="overflow-wrap: break-word; overflow: hidden; text-overflow: ellipsis" :span="24"
                                            >{{ T(`fullcalendar_schedule_surgery.plan_equipment_nurse`) }}：{{ room.equipment_nurse }}
                                        </el-col>
                                    </div>
                                </div>
                                <el-button
                                    icon="el-icon-close"
                                    v-if="room.anesthetist || room.anesthetist_assistant || room.circuit_nurse || room.equipment_nurse"
                                    type="primary"
                                    title="批量删除手术间人员设置"
                                    plain
                                    size="small"
                                    style="position: absolute; bottom: -16px; right: -8px; padding: 8px"
                                    @click="batchdelete(room.id)"
                                    circle
                                ></el-button>
                            </div>
                        </el-card>
                    </el-col>
                </el-scrollbar>
            </el-col>
            <el-col :span="6" class="padding5">
                <!-- <div>{{ activeRoomScheduled_list }}</div> -->
                <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ 'height': `${this.screenHeight - 216}px`, 'overflow-y': `auto`}">
                    <draggable tag="el-row" v-model="activeRoomScheduled_list" draggable=".scheduled" v-bind="{ group: { name: 'drag_surgery', pull: false, put: false }, animation: 150 }" @start="onStart" @change="dragSort">
                    <div
                        class="items"
                        v-for="surgery in activeRoomScheduled_list"
                        :key="surgery.id"
                        :class="surgery.enum_surgery_status >= 40 ? 'done' : surgery.enum_surgery_status == 30 ? 'doing' : 'scheduled'"
                        @click="handleEventClick(surgery)"
                        @dblclick="handleEventDblClick(surgery)"
                    >
  <el-row class="ellipsis rowheight">
                            <el-col :span="5" class="align-left"> {{ surgery.plan_time && $moment(surgery.plan_time).format(`HH:mm`) }}</el-col>
                            <el-col :span="5" class="align-left"> 台次:{{ surgery.sequence_s }}</el-col>
                                    <el-col :span="14" class="align-right">
                                        <span v-for="item in customMenuNames" :key="item.key" style="margin-left: 6px" @click.stop="windowOpen(surgery, item)" :title="item.name">
                                            <text-formatter type="icons" v-model="item.icon" class="width50"></text-formatter>
                                        </span>
                                    </el-col>
                                </el-row>
                        <el-row class="ellipsis" style="height: 20px;">
                                    <el-col :span="24" class="align-left">
                            <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white" size="mini">{{
                                surgery.enum_visit_type
                            }}</el-tag>
                                        <el-tag
                                            class="align-left"
                                            :style="{
                                                color: surgery.enum_surgery_type > 1 ? '#2A918A' : 'red',
                                                borderColor: surgery.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }"
                                            size="mini"
                                            v-if="surgery.surgery_type"
                                            >{{ surgery.surgery_type }}</el-tag
                                        >
                                        <el-tag
                                            class="align-left"
                                            :style="{
                                                color:'#2A918A',
                                                borderColor: '#2A918A',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }"
                                            size="mini"
                                            v-if="surgery.is_day_surgery=='是'||surgery.is_day_surgery==true"
                                            >日间</el-tag
                                        >
                                        <el-tag
                                            class="align-left"
                                            :style="{
                                                color:'#2A918A',
                                                borderColor: '#2A918A',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }"
                                            size="mini"
                                            v-if="surgery.is_endoscopy=='是'||surgery.is_endoscopy==true"
                                            >内镜</el-tag
                                        >
                                    </el-col>
                        </el-row>
                        <el-row class="ellipsis">
                            {{ `${surgery.patient_name}(${surgery.sex || '--'}/${surgery.age || '--'}/${surgery.visit_no || '--'}/${surgery.bed_no || '--'}床)` }}
                            <font-awesome-icon
                                v-show="surgery.ischecked"
                                style="position: absolute;right: 2px;"
                                :icon="['fa', 'check-circle']"
                                size="lg"
                                :style="{ background: 'radial-gradient(red 60%,transparent 60%)' }"
                            ></font-awesome-icon>
                        </el-row>
                        <div class="ellipsis rowheight" v-for="item in userListColumn" :key="item.key">{{ item.label }}:{{ surgery[item.prop] }}</div>
                    </div>
                    </draggable>
                </el-scrollbar>
            </el-col>
        </el-row>
        <div v-if="msgDialogVisible" class="menu_box" :style="{ left: menuLeft + 'px', top: menuTop + 'px' }">
            <div class="menu">
                <div v-show="activeRoom && activeRoom.anesthetist" class="menu_item item_text" @click="deleteWorker(1)">取消{{ T(`fullcalendar_schedule_surgery.plan_anes_doctor`) }}</div>
                <div v-show="activeRoom && activeRoom.anesthetist_assistant" class="menu_item item_text" @click="deleteWorker(2)">取消{{ T(`fullcalendar_schedule_surgery.plan_anes_assistants`) }}</div>
                <div v-show="activeRoom && activeRoom.circuit_nurse" class="menu_item item_text" @click="deleteWorker(3)">取消{{ T(`fullcalendar_schedule_surgery.plan_circuit_nurse`) }}</div>
                <div v-show="activeRoom && activeRoom.equipment_nurse" class="menu_item item_text" @click="deleteWorker(4)">取消{{ T(`fullcalendar_schedule_surgery.plan_equipment_nurse`) }}</div>
                <div v-show="activeRoom && activeRoomScheduled_list && activeRoomScheduled_list.length > 0" class="menu_item item_text" @click="CancelSchedule">取消排程</div>
                <div v-show="hasClose" class="menu_item item_text" @click="msgDialogVisible = false">关闭</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
export default {
    name: `BedCardView`,
    components: { draggable },
    props: {
        operationRooms: Array,
        rdate: String,
        customMenuNames: Array
    },
    data() {
        return {
            roomLabelTitle: `已完成/排程总数`,
            tmp_active_room_id: 0,
            activeRoomScheduled_list: [],
            activeRoomScheduled_list_copy: [],
            alloperationRooms: [],
            menuLeft: 0,
            menuTop: 0,
            msgDialogVisible: false,
            activeRoom: {}
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([
            `surgery/visit_type`,
            `surgery/anaesthesia_method`,
            `operation_room_auth`,
            `section_auth`,
            `operation_ward_auth`,
            `sys_enums`,
            `sysuser/workers_by_duty`,
            `permissions`,
            `sysuser/workers_by_dutyNew`,
            `active_ward`,
            `otherSettingColumn`,
            `extendColumnList`,
            `screenHeight`,
            `screenWidth`,
            `business`
        ]),
        isHaveCardEdit() {
            return _.find(this.permissions, { no: `scheduling_surgeryEdit` }) != undefined
        },
        hasClose() {
            return this.activeRoom && (this.activeRoom.anesthetist || this.activeRoom.anesthetist_assistant || this.activeRoom.circuit_nurse || this.activeRoom.equipment_nurse ||
            (this.activeRoomScheduled_list && this.activeRoomScheduled_list.length > 0))
        },
        userListColumn() {
            return this.$parent && this.$parent.userListColumn
        },
        active_room_id: {
            get: function() {
                if (this.tmp_active_room_id == 0 && this.operationRooms.length > 0) {
                    this.tmp_active_room_id = this.operationRooms[0].id
                }

                return this.tmp_active_room_id
            },
            set: function(v) {
                this.tmp_active_room_id = v
            }
        }
    },
    methods: {
        cancelWorkers(e, room) {
            let that = this
            if (room && room.id > 0) {
                that.active_room_id = room.id
                that.menuLeft = e && e.clientX || 0
                that.menuTop = e && e.clientY || 0
                that.activeRoom = room
                that.msgDialogVisible = true
            }
        },
        loadCheckList(room) {
            this.$parent && this.$parent.loadCheckList(room)
        },
        loadSettingForm(id, title, room) {
            this.$parent && this.$parent.loadSettingForm(id, title, room)
        },
        loadActiveRoomScheduled(rdate, roomId) {
            // 获取各手术间排程数据
            let that = this
            that.$parent.selectedEvents = []
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetScheduled`, { date: rdate, roomId: roomId })
                req.then(data => {
                    let r = data
                    r = r.map(d => {
                        if (d.scheduled_sequence && this.IsNum(d.scheduled_sequence)) {
                            d.sequence_s = d.scheduled_sequence && parseInt(d.scheduled_sequence)
                        } else {
                            d.sequence_s = d.scheduled_sequence
                        }
                        d.ischecked = false
                        _.each(d, (value, key) => {
                            /* eslint valid-typeof: "error" */
                            if (typeof d[key] == `boolean` && key != `ischecked`) {
                                if (d[key] == true) {
                                    d[key] = `是`
                                } else {
                                    d[key] = `否`
                                }
                            } else if (d[key] && (d[key] + ``).indexOf(`/Date`) > -1) {
                                d[key] = this.$moment(d[key]).format(`YYYY/MM/DD HH:mm`)
                            } else if (key == `enum_visit_type`) {
                                if (d[key] == 1) {
                                    d[key] = `住院`
                                } else if (d[key] == 2) {
                                    d[key] = `门诊`
                                } else if (d[key] == 3) {
                                    d[key] = `体检`
                                } else {
                                    d[key] = ``
                                }
                            }
                        })
                        return d
                    })
                    let r1 = _.orderBy(r, [`sequence_s`, `plan_time`])
                    that.activeRoomScheduled_list = r1
                    resolve(r1)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        onStart($event) {
            this.activeRoomScheduled_list_copy = []
            this.activeRoomScheduled_list_copy = _.cloneDeep(this.activeRoomScheduled_list)
        },
        dragSort($event) {
            let that = this
            let {
                moved: { newIndex, oldIndex }
            } = $event
            let newrow = this.activeRoomScheduled_list_copy[newIndex]
            let oldrow = this.activeRoomScheduled_list_copy[oldIndex]
            if (newrow.enum_surgery_status >= 30) {
                that.$message.error(`手术中或已完成的手术无法更换台次`)
                newrow.sequence_s = oldrow.sequence_s
                return
            }
            let req = this.myaxios.put(`/api/Preoperative/Schedule/JumpSequence/${oldrow.id}?oldsequence=${oldrow.sequence_s}&sequence=${newrow.sequence_s}`)
            req.then(() => {
                that.activeRoomScheduled_list_copy = []
                that.$parent.refetch()
                that.refresh()
                that.$message.success(`台次调整成功`)
            })
        },
        deleteWorker(type) {
            let that = this
            if (!that.activeRoom || !that.activeRoom.id) {
                return
            }
            var msg = ``
            switch (type) {
            case 1:
                msg = that.T(`fullcalendar_schedule_surgery.plan_anes_doctor`)
                break
            case 2:
                msg = that.T(`fullcalendar_schedule_surgery.plan_anes_assistants`)
                break
            case 3:
                msg = that.T(`fullcalendar_schedule_surgery.plan_circuit_nurse`)
                break
            case 4:
                msg = that.T(`fullcalendar_schedule_surgery.plan_equipment_nurse`)
                break
            default:
                msg = ``
                break
            }
            return this.$confirm(`请确认删除手术间${msg}?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                return new Promise(resolve => {
                    let req2 = that.myaxios.post(`/api/Preoperative/RoomSetting/DeleteWorker?dateTime=${this.rdate}&operatingRoomId=${that.activeRoom.id}&deleteType=${type}`)
                    req2.then(data => {
                        that.msgDialogVisible = false
                        that.$parent.refetch()
                        that.refresh()
                        that.$message.success(`删除成功`)
                        resolve([])
                    }).catch(e => {

                    })
                })
            }).catch(e => {})
        },
        refreshList(info) {
            if (info && info.id) {
                _.forEach(this.activeRoomScheduled_list, s => {
                    if (s.id == info.id) {
                        s.ischecked = false
                    }
                })
            }
        },
        CancelSchedule() {
            let that = this
            return this.$confirm(`确定取消手术间所有已排程手术？`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                return new Promise(resolve => {
                    let req2 = that.myaxios.post(`/api/Preoperative/RoomSetting/CancelSchedule?dateTime=${that.rdate}&operatingRoomId=${that.activeRoom.id}`)
                    req2.then(data => {
                        that.msgDialogVisible = false
                        that.$parent.refetch()
                        that.refresh()
                        that.$message.success(`取消成功`)
                        resolve([])
                    }).catch(e => {

                    })
                })
            }).catch(e => {})
        },
        batchdelete(roomId) {
            let that = this
            return this.$confirm(`请确认删除手术间设置人员?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                return new Promise(resolve => {
                    let req2 = that.myaxios.delete(`/api/Preoperative/RoomSetting/DeleteRoomSetting?dateTime=${this.rdate}&operatingRoomId=${roomId}`)
                    req2.then(data => {
                        that.$parent.refetch()
                        that.refresh()
                        that.$message.success(`批量删除手术间设置人员成功`)
                        resolve([])
                    }).catch(e => {

                    })
                })
            }).catch(e => {})
        },
        // true:数值型的，false：非数值型
        IsNum(value) {
            return typeof value === `number` && !isNaN(value)
        },
        getDraggleAttrs(id) {
            return {
                attrs: {
                    id: id
                }
            }
        },
        exchangeRoom($event) {
            let that = this
            let from = $event.from
            // from.innerHTML = `<span id="${from.id}" style="font-weight: bold; font-size: 22px;">${from.innerText}</span>`
            let oldRoomId = from.id
            let to = $event.to
            let newRoomId = to.id
            let fromRoom = _.find(that.alloperationRooms, { id: parseInt(oldRoomId) })
            let toRoom = _.find(that.alloperationRooms, { id: parseInt(newRoomId) })
            let toName = (toRoom && toRoom.title) || ``
            to.innerHTML = `<span id="${to.id}" style="font-weight: bold; font-size: 22px;">${toName}</span>`
            let date = that.$moment(this.rdate).format(`YYYY-MM-DD`)

            that.$confirm(`确认将 ${fromRoom.title} 与 ${toRoom.title} 当日手术进行交换?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let req = that.myaxios.put(`/api/Preoperative/Schedule/ExchangeRoom?roomA=${oldRoomId}&roomB=${newRoomId}&date=${date}`)
                    req.then(data => {
                        that.$parent.refetch()
                        that.refresh()
                        that.$message.success(`交换成功`)
                    }).catch(e => {
                        that.$message.error(`交换失败`)
                    })
                })
                .catch(e => {})
        },
        handleEventDblClick(surgery) {
            let that = this

            that.$parent.edit.surgeryId = parseInt(surgery.id)
            that.$parent.edit.dialogFormVisible = true
            that.$parent.edit.isReadOnly = !that.isHaveCardEdit
            return false
        },
        handleEventClick(surgery) {
            let that = this
            surgery.ischecked = !surgery.ischecked
            if (surgery.ischecked) {
                that.$parent.removeLeftSelectData(surgery.id)
                that.$parent.selectedEvents.push(surgery)
            } else {
                _.remove(that.$parent.selectedEvents, function(item) {
                    return item.id == surgery.id
                })
            }
        },
        refresh() {
            this.loadActiveRoomScheduled(this.rdate, this.active_room_id)
        },
        setRoomDutyWorker(workerDuty, workerIds) {
            let row = this.alloperationRooms.find(i => i.id == this.active_room_id)
            let that = this
            let surgeryIds = []
            let r = {
                id: row.room_setting_id,
                date: that.rdate,
                dic_operating_room_id: row.id,
                dic_operating_room: {
                    id: row.id
                },
                anesthetist_id: row.anesthetist_id,
                anesthetist_assistant_id: row.anesthetist_assistant_id && row.anesthetist_assistant_id.toString(),
                circuit_nurse_id: row.circuit_nurse_id && row.circuit_nurse_id.toString(),
                equipment_nurse_id: row.equipment_nurse_id && row.equipment_nurse_id.toString(),
                dic_section_id: row.dic_section_id || `-1`,
                surgeon_id: row.surgeon_id || `-1`,
                dic_surgery_name: row.dic_surgery_name,
                is_extra: true,
                surgeryIds: surgeryIds
            }
            if (workerIds && workerIds.length > 0) {
                if (workerDuty == 1) {
                    r.anesthetist_id = workerIds.join(`,`)
                }
                if (workerDuty == 2) {
                    if (r.anesthetist_assistant_id) {
                        r.anesthetist_assistant_id = r.anesthetist_assistant_id + `,` + workerIds.join(`,`)
                    } else {
                        r.anesthetist_assistant_id = workerIds.join(`,`)
                    }
                }
                if (r.anesthetist_assistant_id) {
                    let assistantIds = r.anesthetist_assistant_id.split(`,`)

                    r.anesthetist_assistant_id = [...new Set(assistantIds)].join(`,`)
                }

                if (workerDuty == 3) {
                    if (r.circuit_nurse_id) {
                        r.circuit_nurse_id = r.circuit_nurse_id + `,` + workerIds.join(`,`)
                    } else {
                        r.circuit_nurse_id = workerIds.join(`,`)
                    }
                }
                if (r.circuit_nurse_id) {
                    let circuitIds = r.circuit_nurse_id.split(`,`)
                    r.circuit_nurse_id = [...new Set(circuitIds)].join(`,`)
                }

                if (workerDuty == 4) {
                    if (r.equipment_nurse_id) {
                        r.equipment_nurse_id = r.equipment_nurse_id + `,` + workerIds.join(`,`)
                    } else {
                        r.equipment_nurse_id = workerIds.join(`,`)
                    }
                }
                if (r.equipment_nurse_id) {
                    let equipIds = r.equipment_nurse_id.split(`,`)
                    r.equipment_nurse_id = [...new Set(equipIds)].join(`,`)
                }
                r.workerDuty = workerDuty
            }
            return new Promise(resolve => {
                let req = that.myaxios.put(`/api/Preoperative/RoomSetting/Put`, r)
                req.then(data => {
                    that.$parent.refetch()
                    that.$message.success(`保存成功`)
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        windowOpen(event, menuInfo) {
            let that = this
            let date = that.$moment(event.plan_time).format(`YYYY/MM/DD`)
            this.openUrl(menuInfo, event, date)
        },
        openUrl(menuInfo, event, date) {
            console.log(menuInfo)
            let url = (menuInfo && menuInfo.url) || `/`
            // 第三方链接直接弹框打开，不用二次弹框打开
            if (url.indexOf(`source=`) > -1) {
                url = decodeURIComponent(url.split(`source=`)[1])
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${event.id}&rdate=${date}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                this.windowOpenUrl(event.id, url)
            } else {
                // 本系统页面链接，直接调用患者管理路由加载界面
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${event.id}&rdate=${date}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                let routeUrl = this.$router.resolve({
                    path: url
                })
                var w = this.screenWidth - 10
                var h = this.screenHeight - 10
                if (typeof winformMsg != `undefined`) {
                    w = w + 500
                    h = h + 400
                }
                window.open(routeUrl.href, ``, `width=${w},height=${h},top=10,left=10`)
            }
        }

    },
    watch: {
        active_ward: function() {
        },
        operationRooms: function(newValue, oldValue) {
            if (newValue.length != oldValue.length) {
                this.tmp_active_room_id = 0
            }
            this.alloperationRooms = newValue
        },
        rdate: function() {
            this.loadActiveRoomScheduled(this.rdate, this.active_room_id)
        },
        active_room_id: function() {
            this.loadActiveRoomScheduled(this.rdate, this.active_room_id)
        }
    }

}
</script>
<style scoped>
</style>
<style lang="less">
.bedcardview {
    .bed-card > div {
        margin: 5px;
        .el-card__header {
            padding: 10px 20px;
        }
        .content {
            height: 120px;
            max-height: 120px;
            padding-top: 10px;
            .item {
                // border: 1px;
                // border-radius: @border-radius;
                // border-color: @fgcolor;
                // background-color: @fgcolor;
                height: 26px;
                overflow-wrap: break-word;
                color: rgba(96, 98, 102, 1);
                font-size: 15px;
                font-family: MicrosoftYaHei;
                font-weight: normal;
                text-align: left;
                white-space: nowrap;
                line-height: 26px;
                // margin: 4px 10px 10px 8px;
            }
        }
        &.active {
            background: var(--primary-light, rgba(226, 245, 244, 1));
            border: solid 0.5px var(--primary-hover, #33aba0);
            font-weight: bold;
            // color: red;
            opacity: 1;
        }
    }
    .items {
        text-align: left;
        color: white;
        padding: 5px;
        border-radius: 5px;
        margin: 6px auto;
        width: 90%;
    }
    .scheduled {
        background-color: var(--primary-color, #33aba0);
    }
    .doing {
        background-color: rgb(244, 67, 54);
    }
    .done {
        background-color: rgb(220, 223, 230);
        color: rgb(51, 51, 51);
    }
}
.menu_box {
    position: fixed;
    z-index: 1004;
    background-color: #fff;
    .menu {
        width: 150px;
        text-align: left;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .menu_item {
            height: 24px;
            line-height: 22px;
        }
        .item_text {
            color: #171a1d;
            cursor: pointer;
            padding: 4px 20px;
            transition: all 0.2s ease-in;
        }
        .item_text:hover {
            background-color: #e9eaec;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/BedCardView.vue